// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);

/* Keep matching bow imagery aligned after variant-picker section morphs. */
{
  const selectedColors = new Map();
  let pending = false;
  const updateBows = () => {
    pending = false;
    document.querySelectorAll('pawture-plaid-bow[data-product-id]').forEach((bow) => {
      const productId = bow.dataset.productId;
      const pickers = [...document.querySelectorAll('variant-picker')].filter(picker => picker.dataset.productId === productId && !picker.closest('product-card, quick-add-dialog'));
      const checked = pickers.flatMap(picker => [...picker.querySelectorAll('input:checked, select option:checked')]).find(option => (option.dataset.optionName || option.closest('select')?.dataset.optionName || '').toLowerCase() === 'color');
      const color = selectedColors.get(productId) || checked?.value || bow.dataset.initialColor;
      let images;
      try { images = JSON.parse(bow.querySelector('script[type="application/json"]')?.textContent || '{}'); } catch { return; }
      const item = images[color];
      if (!item) return;
      const next = 'url("' + item.url + '")';
      if (bow.style.backgroundImage !== next) bow.style.backgroundImage = next;
      bow.style.backgroundSize = 'contain';
      bow.style.backgroundPosition = 'center';
      bow.dataset.color = color;
      bow.setAttribute('aria-label', color + ' matching bow tie');
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(updateBows); } };
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLElement)) return;
    const picker = input.closest('variant-picker');
    if (!picker || input.closest('product-card, quick-add-dialog')) return;
    const option = input instanceof HTMLSelectElement ? input.selectedOptions[0] : input;
    if ((option?.dataset.optionName || input.dataset.optionName || '').toLowerCase() === 'color') selectedColors.set(picker.dataset.productId, input.value);
    schedule();
  }, true);
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });
  window.addEventListener('popstate', () => { selectedColors.clear(); schedule(); });
  schedule();
}

{
  const restoreHomepageEngraving = () => {
    let draft;
    try { draft = JSON.parse(sessionStorage.getItem('pawture-home-engraving') || 'null'); } catch { return; }
    if (!draft || draft.handle !== 'maison-tweed-dog-collar' || !Array.isArray(draft.lines) || draft.lines.length !== 2 || !Number.isFinite(draft.time)) return;
    if (Date.now() - draft.time > 1800000 || Date.now() < draft.time) {
      try { sessionStorage.removeItem('pawture-home-engraving'); } catch {}
      return;
    }
    if (!/(?:^|\/)products\/maison-tweed-dog-collar\/?$/.test(location.pathname)) return;
    const fields = [1, 2].map(number => document.querySelector('.product-information input[name="properties[Engraving line ' + number + ']"]'));
    if (fields.some(field => !field)) return;
    fields.forEach((field, i) => {
      if (field.value || typeof draft.lines[i] !== 'string') return;
      field.value = Array.from(draft.lines[i]).slice(0, 15).join('');
      field.dispatchEvent(new Event('input', { bubbles:true }));
      field.dispatchEvent(new Event('change', { bubbles:true }));
    });
    try { sessionStorage.removeItem('pawture-home-engraving'); } catch {}
  };
  requestAnimationFrame(restoreHomepageEngraving);
}
